/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataUpdateReqVo
 */
export interface NodataUpdateReqVo {
    /**
     * 无数据记录ID（优先；传了则按 id 更新）
     * @type {number}
     * @memberof NodataUpdateReqVo
     */
    id?: number;
    /**
     * 仓库ID（不传 id 时必填）
     * @type {number}
     * @memberof NodataUpdateReqVo
     */
    warehouseId?: number;
    /**
     * 快递单号（即扫描码；不传 id 时必填）
     * @type {string}
     * @memberof NodataUpdateReqVo
     */
    trackingNumber?: string;
    /**
     * 操作员ID(staff.id)（不传 id 时必填）
     * @type {number}
     * @memberof NodataUpdateReqVo
     */
    workerId?: number;
    /**
     * 客户编号（POST_NO），用于关联用户；不传则登记为无归属，进公共区域管理
     * @type {string}
     * @memberof NodataUpdateReqVo
     */
    postNo?: string;
    /**
     * Coupang入库码（返送订单场景补录）
     * @type {string}
     * @memberof NodataUpdateReqVo
     */
    coupangInboundCode?: string;
    /**
     * 到付金额（首次创建时使用）
     * @type {number}
     * @memberof NodataUpdateReqVo
     */
    carriageForward?: number;
    /**
     * 是否返送订单场景：0=非返送，1=返送
     * @type {number}
     * @memberof NodataUpdateReqVo
     */
    returnFromCoupang?: number;
}

/**
 * Check if a given object implements the NodataUpdateReqVo interface.
 */
export function instanceOfNodataUpdateReqVo(value: object): value is NodataUpdateReqVo {
    return true;
}

export function NodataUpdateReqVoFromJSON(json: any): NodataUpdateReqVo {
    return NodataUpdateReqVoFromJSONTyped(json, false);
}

export function NodataUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'workerId': json['workerId'] == null ? undefined : json['workerId'],
        'postNo': json['postNo'] == null ? undefined : json['postNo'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'carriageForward': json['carriageForward'] == null ? undefined : json['carriageForward'],
        'returnFromCoupang': json['returnFromCoupang'] == null ? undefined : json['returnFromCoupang'],
    };
}

export function NodataUpdateReqVoToJSON(json: any): NodataUpdateReqVo {
    return NodataUpdateReqVoToJSONTyped(json, false);
}

export function NodataUpdateReqVoToJSONTyped(value?: NodataUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'warehouseId': value['warehouseId'],
        'trackingNumber': value['trackingNumber'],
        'workerId': value['workerId'],
        'postNo': value['postNo'],
        'coupangInboundCode': value['coupangInboundCode'],
        'carriageForward': value['carriageForward'],
        'returnFromCoupang': value['returnFromCoupang'],
    };
}

